import { render, staticRenderFns } from "./storefront-data-permission-widget.vue?vue&type=template&id=7034f964&"
import script from "./storefront-data-permission-widget.vue?vue&type=script&lang=js&"
export * from "./storefront-data-permission-widget.vue?vue&type=script&lang=js&"
import style0 from "./storefront-data-permission-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports